import { useCallback } from 'react';
import { ProjectsReportAPI } from 'api/projects-report';
import { ApiProjectsReportExportType } from 'api/projects-report/api-types';
import { Filter } from 'components/molecules/filters/types';
import { toastService } from 'components/molecules/toast';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { TranslationKey, useTranslate } from 'hooks/use-translation';
import { logger } from 'services';

export enum ProjectsReportView {
  Timelines = 'timelines',
  PhasesAndTasks = 'phases_and_tasks',
}

export const useExport = (
  range: DateRange,
  { criteria, type }: Filter,
  view: ProjectsReportView,
): { exportAsCSV: () => void } => {
  const translate = useTranslate();

  const exportAsCSV = useCallback(() => {
    ProjectsReportAPI.exportAsCSV(
      range,
      criteria.filter(FieldFilter.isValid),
      type,
      view === ProjectsReportView.Timelines
        ? ApiProjectsReportExportType.Timeline
        : ApiProjectsReportExportType.PhasesAndTasks,
    )
      .then((downloadUrl) => {
        window.open(downloadUrl, '_blank');
      })
      .catch((error) => {
        logger.error('error in exporting projects report', { error });
        toastService({
          title: translate('failure' as TranslationKey),
          message: translate(
            'reports.project_performance.export.error' as TranslationKey,
          ),
        }).error();
      });
  }, [criteria, range, type, view, translate]);

  return {
    exportAsCSV,
  };
};
